import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

const styles = theme => ({
  listItem: {
    color: theme.palette.text.primary,
    minWidth: 140,
    padding: 0,
    '& + $listItem': {
      paddingTop: 15,
    },
  },
});

const OrdersTableRowSalesRepresentatives = ({ classes, ...otherProps }) => (
  <List disablePadding>
    {otherProps['Sales Representative'].map(item => (
      <ListItem
        key={item.ID}
        className={classes.listItem}
      >
        {`${item['First Name']} ${item['Last Name']}`}
      </ListItem>
    ))}
  </List>
);

OrdersTableRowSalesRepresentatives.propTypes = {
  'Sales Representative': PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.number.isRequired,
      'First Name': PropTypes.string.isRequired,
      'Last Name': PropTypes.string.isRequired,
    }),
  ).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(OrdersTableRowSalesRepresentatives);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowSalesRepresentatives.js